import './src/styles/global.scss';

export const onClientEntry = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v2';
  document.head.appendChild(link);
};
 